var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('ErrorButton',{staticClass:"mr-2",attrs:{"shrink":"","light":""},nativeOn:{"click":function($event){return _vm.openDeleteTierDialog.apply(null, arguments)}}},[_vm._v(" Remove ")]),_c('DeleteTierDialog',{attrs:{"tierId":_vm.tierId,"isOpen":_vm.isDialogOpen},on:{"close":_vm.closeDeleteTierDialog,"deleted":_vm.handleDeleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }